var map = {
	"./404.html": 1245,
	"./_template.jsx": 377,
	"./about.js": 1246,
	"./blog-store/2016-11-20-gatsbyjs-for-portfolio-site/index.md": 1736,
	"./blog-store/_legacyindex.js": 1737,
	"./blog.js": 1746,
	"./html.html": 1747,
	"./index.js": 1748,
	"./json": 1758,
	"./json.json": 1758,
	"./markdown.md": 1759,
	"./music.js": 1760,
	"./react.js": 1761,
	"./toml": 1762,
	"./toml.toml": 1762,
	"./works/brand-x-line-hack/index.jsx": 1763,
	"./works/digimagic-projects/index.js": 1778,
	"./works/index.js": 1791,
	"./works/inline-at-line-hack/index.jsx": 1792,
	"./works/meditech-senze/index.jsx": 1793,
	"./works/microbrik/index.jsx": 1796,
	"./works/mobile-reality-boxing/index.js": 1797,
	"./works/osmep-business-intelligence/index.jsx": 1798,
	"./works/osmep-sme-tracking/index.jsx": 1799,
	"./works/resus-ultrasound/index.jsx": 1800,
	"./works/runnables-branding-kit/index.jsx": 1801,
	"./works/skinspiel/index.js": 1802,
	"./works/ucheckpoint/index.jsx": 1803,
	"./yaml": 1804,
	"./yaml.yaml": 1804
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1244;



/*****************
 ** WEBPACK FOOTER
 ** . (coffee|cjsx|ts|tsx|jsx|js|md|rmd|mkdn?|mdwn|mdown|markdown|litcoffee|ipynb|html|json|yaml|toml)$
 ** module id = 1244
 ** module chunks = 0
 **/